module.exports = __webpack_public_path__ + "static/media/jasmine-logo.8316e471.png";


//////////////////
// WEBPACK FOOTER
// ./src/jasmine-logo.png
// module id = 42
// module chunks = 0